import React from "react";
import styled from "styled-components";
import {Th} from "../../../elements/Tables";

const HeaderContainer = styled.div`
    display: flex;
    cursor: pointer;
`;

const HeadingText = styled.span`
    margin-right: 3px;
`;

const Heading = ({onClick, className, text, sortIcon}) => {
    return <Th>
        <HeaderContainer onClick={onClick} className={className}>
            <HeadingText>{text}</HeadingText>
            {sortIcon}
        </HeaderContainer>
    </Th>;
};

export default Heading;